import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'bdo-accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccordionItemComponent {
  /**
   * If the panel is opened or closed
   */
  @Input() opened = false;

  /**
   * Text to display in the item title bar
   */
  @Input() title: string;

  /**
   * Emitted when user clicks on item titlebar
   * @type {EventEmitter<any>}
   */
    // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();

  public buttonId: string = 'accordion-button-' + uuidv4();
  public contentId: string = 'accordion-panel-' + uuidv4();

  itemSelected(itemContainer: HTMLElement = null) {
    if (!this.opened) {
      setTimeout(() => {
        itemContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    this.toggle.emit();
  }
}
